import { render } from "./AdTile.vue?vue&type=template&id=36dcb50a"
import script from "./AdTile.vue?vue&type=script&setup=true&lang=js"
export * from "./AdTile.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Mask/Tiles/components/AdTile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36dcb50a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36dcb50a', __exports__)) {
    api.reload('36dcb50a', __exports__)
  }
  
  module.hot.accept("./AdTile.vue?vue&type=template&id=36dcb50a", () => {
    api.rerender('36dcb50a', render)
  })

}


export default __exports__